import styled, { css } from "styled-components";

import {
  DeleteButton,
  DeleteButtonWrapper,
  FixedWrapper,
} from "@FillInTableContainer/shared/styles/deleteButton.style";
import {
  DefaultDraggableGroupShellWrapper,
  GroupShellTitleWrapper,
  OutsideWrapper,
} from "@FillInTableContainer/shared/styles/groupShell.style";
import {
  SelectButton,
  SelectButtonDivider,
  SelectButtonDividerWrapper,
  SelectContentWrapper,
} from "@FillInTableContainer/shared/styles/rowSelectButton.style";
import { ScrollTableWrapper } from "@FillInTableContainer/shared/styles/tableScroll.style";

export const GroupShellOutsideWrapper = styled.div`
  position: relative;
  padding-left: 0;
`;

// VF Asset Transfer 를 LA&SC Rights Scope 처럼 가로 테이블로 렌더하기 위한 스타일.
// isTableScroll(=isAssetTransfer) 가 false 면 일반 div 처럼 동작하여 다른 섹션에 영향 없음.
export const AssetTransferScrollWrapper = styled(ScrollTableWrapper)``;

export const AssetTransferScrollContents = styled.div<{ $isTable: boolean }>`
  width: ${({ $isTable }) => ($isTable ? "fit-content" : "100%")};
`;

export const GroupShellHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  /* 그룹 레벨(1.6rem) + 서브그룹 레벨(1.6rem) SELECT divider 만큼 들여써서
     아래 데이터 셀과 좌측 정렬을 맞춘다. */
  padding-left: 3.2rem;
  border: 2px solid transparent;
`;

export const GroupShellHeader = styled.div<{
  minWidth: string;
  maxWidth: string;
}>`
  display: flex;
  min-width: ${({ minWidth }) => minWidth};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  padding: 0.6rem 0.8rem 0.6rem var(--Spacing-8, 0.8rem);
  align-items: flex-start;
  flex: 1 0 0;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  background-color: #fff;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
`;

export const GroupShellWrapper = styled(OutsideWrapper)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const GroupShell = styled.div<{ $noGap?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $noGap }) => ($noGap ? "0" : "0.8rem")};
  width: 100%;
`;

export const FixedDeleteButtonWrapper = styled(FixedWrapper)<{
  isShellTitle: boolean;
  isSeparatedTitleRow?: boolean;
  isSeparatedTitlePosition?: number;
}>`
  top: -2.4rem;
  left: -0.2rem;
  right: auto;

  ${({ isShellTitle }) =>
    isShellTitle &&
    css`
      top: -2.4rem;
      left: -0.2rem;
    `}
`;

export const DeleteTableButtonWrapper = styled(DeleteButtonWrapper)``;

export const DeleteTableButton = styled(DeleteButton)``;

export const SelectWrapper = styled(SelectContentWrapper)<{
  $isAssetTransfer?: boolean;
}>`
  ${({ $isAssetTransfer }) =>
    $isAssetTransfer &&
    css`
      padding: 0;
    `}
`;

export const GroupShellSelectButton = styled(SelectButton)``;

export const GroupShellSelectButtonDivider = styled(SelectButtonDivider)``;

export const GroupShellSelectButtonDividerWrapper = styled(
  SelectButtonDividerWrapper,
)<{ isFinancialTerms: boolean }>`
  ${({ isFinancialTerms }) =>
    isFinancialTerms &&
    css`
      display: none;
    `}
`;

export const TitleWrapper = styled(GroupShellTitleWrapper)``;
export const DraggableSubGroupShellWrapper = styled(
  DefaultDraggableGroupShellWrapper,
)`
  /* Asset Transfer 행의 add 바(absolute)가 이 래퍼 기준으로 위치하도록 relative */
  position: relative;
`;
